"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyAnswerStatisticsToJSON = exports.SurveyAnswerStatisticsFromJSONTyped = exports.SurveyAnswerStatisticsFromJSON = exports.instanceOfSurveyAnswerStatistics = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyAnswerStatistics interface.
 */
function instanceOfSurveyAnswerStatistics(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyAnswerStatistics = instanceOfSurveyAnswerStatistics;
function SurveyAnswerStatisticsFromJSON(json) {
    return SurveyAnswerStatisticsFromJSONTyped(json, false);
}
exports.SurveyAnswerStatisticsFromJSON = SurveyAnswerStatisticsFromJSON;
function SurveyAnswerStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'answerText': !(0, runtime_1.exists)(json, 'answer_text') ? undefined : json['answer_text'],
        'controlAnswerCount': !(0, runtime_1.exists)(json, 'control_answer_count') ? undefined : json['control_answer_count'],
        'controlAnswerRate': !(0, runtime_1.exists)(json, 'control_answer_rate') ? undefined : json['control_answer_rate'],
        'exposedAnswerCount': !(0, runtime_1.exists)(json, 'exposed_answer_count') ? undefined : json['exposed_answer_count'],
        'exposedAnswerRate': !(0, runtime_1.exists)(json, 'exposed_answer_rate') ? undefined : json['exposed_answer_rate'],
        'optionKey': !(0, runtime_1.exists)(json, 'option_key') ? undefined : json['option_key'],
    };
}
exports.SurveyAnswerStatisticsFromJSONTyped = SurveyAnswerStatisticsFromJSONTyped;
function SurveyAnswerStatisticsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'answer_text': value.answerText,
        'control_answer_count': value.controlAnswerCount,
        'control_answer_rate': value.controlAnswerRate,
        'exposed_answer_count': value.exposedAnswerCount,
        'exposed_answer_rate': value.exposedAnswerRate,
        'option_key': value.optionKey,
    };
}
exports.SurveyAnswerStatisticsToJSON = SurveyAnswerStatisticsToJSON;
